var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-button',{attrs:{"tooltip":_vm.$t('actions.delete'),"color":"blue-grey","icon":"delete","confirm-dialog":"","confirm-text":_vm.confirmText,"strong-confirm":_vm.strong,"approve-color":"error"},on:{"execute":_vm.execute}})}
var staticRenderFns = []

export { render, staticRenderFns }